import { addCopilotContext as e, addCopilotInstruction as t, addCopilotTool as n } from "../global-state.js";
import { useCallback as r, useEffect as i, useRef as a } from "react";
//#region src/react/global-state.ts
function o(e) {
	let n = e.isEnabled ?? !0, r = "session" in e, a = e.session ?? null;
	return i(() => {
		if (n === !1 || r && a == null) return;
		let i = a == null ? t(e) : a.addInstruction({ instruction: e.instruction });
		return () => i();
	}, [
		n,
		r,
		a,
		e.instruction
	]);
}
function s(e) {
	let t = e.isEnabled ?? !0, r = "session" in e, o = e.session ?? null, s = "handler" in e ? e.handler : void 0, c = a(s);
	c.current = s;
	let l = s != null, u = a(e.render);
	u.current = e.render;
	let d = e.render != null, f = a(e.needsApproval);
	f.current = e.needsApproval;
	let p = e.needsApproval != null, m = e.humanInTheLoop === !0;
	return i(() => {
		if (t === !1 || r && o == null) return;
		let i = o == null ? n : (e) => o.addTool(e), a = {
			name: e.name,
			description: e.description,
			requestSchema: e.requestSchema,
			responseSchema: e.responseSchema,
			needsApproval: p ? (e) => typeof f.current == "function" ? f.current(e) : f.current === !0 : void 0,
			render: d ? (e) => u.current?.(e) : void 0
		}, s = i(e.type === "client" ? m ? {
			...a,
			type: e.type,
			humanInTheLoop: !0,
			render: (e) => u.current?.(e)
		} : {
			...a,
			type: e.type,
			handler: (e) => c.current?.(e)
		} : {
			...a,
			type: e.type,
			handler: (e) => c.current?.(e),
			isStreaming: e.isStreaming
		});
		return () => s();
	}, [
		t,
		r,
		o,
		e.type,
		e.name,
		e.description,
		e.requestSchema,
		e.responseSchema,
		p,
		m,
		"isStreaming" in e ? e.isStreaming : !1,
		l,
		d
	]);
}
function c(t) {
	let n = t.isEnabled ?? !0, o = "session" in t, s = t.session ?? null, c = a(t);
	c.current = t;
	let l = r(() => typeof c.current.value == "function" ? c.current.value() : c.current.value, []);
	return i(() => {
		if (n === !1 || o && s == null) return;
		let r = {
			description: t.description,
			value: l
		}, i = s == null ? e(r) : s.addContext(r);
		return () => i();
	}, [
		n,
		o,
		s,
		t.description
	]);
}
//#endregion
export { c as useCopilotContext, o as useCopilotInstruction, s as useCopilotTool };
